import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getLoginUrl } from "../../utils/url-helper";
import { useCliftContext } from "../../hooks/useCliftContext";
import { ReactComponent as MicrosoftLogo } from "../../assets/MicrosoftLogo.svg";
import LogoPlus from "../../assets/LogoPlus.svg";
import "./Login.css";

const Login = () => {
  const { currentUser } = useCliftContext();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const setDefaultLanguage = () => {
    const browserLang = navigator.language.split("-")[0];
    const supported = i18n.options.supportedLngs;

    if (browserLang && supported && supported.includes(browserLang)) {
      i18n.changeLanguage(browserLang);
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("i18nextLng")) {
      setDefaultLanguage();
    }

    if (currentUser === undefined) {
      // Still loading clientPrincipal → do nothing
      return;
    }

    if (currentUser === null) {
      // Not authenticated → stay on login page
      return;
    }

    if (currentUser?.clientPrincipal?.userRoles?.includes("authenticated")) {
      navigate("/", { replace: true });
    }
  }, [currentUser]);

  return (
    <div id="login">
      <div className="login-content">
        <img alt="StannahPlus" id="logo" src={LogoPlus} />
        <div className="login-content-form">
          <div className="login-content-form-title">
            {t("sign_in", { ns: "profile" })}
          </div>
          <div className="login-content-form-subtitle">
            {t("sign_in_admin_access", { ns: "profile" })}
          </div>
          <button className="button">
            <MicrosoftLogo />
            <a
              id="login-microsoft-link"
              href={`${getLoginUrl(i18n.language, false)}`}
            >
              {t("sign_in_with_microsoft", { ns: "profile" })}
            </a>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
